module.exports = __webpack_public_path__ + "img/Z86_18.d15d1e36.jpg";